module.exports = __webpack_public_path__ + "media/assets/images/blog/scream_at_phone-small-440d58163a87f656dbe5bd9a97e9cf5a.jpeg";